const block_icons     = {
    multi_button:    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 32 32"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#e73e16"
      d="M26 32H6a6 6 0 01-6-6V6a6 6 0 016-6h20a6 6 0 016 6v20a6 6 0 01-6 6z"
      data-original="#f5e6fe"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M14 16.667H9.333C8.597 16.667 8 17.264 8 18v4.667C8 23.403 8.597 24 9.333 24H14c.736 0 1.333-.597 1.333-1.333V18c0-.736-.597-1.333-1.333-1.333zm-.667 6H10A.667.667 0 019.333 22v-2.667H14V22a.667.667 0 01-.667.667zM22.667 16.667H18c-.736 0-1.333.597-1.333 1.333v4.667c0 .736.597 1.333 1.333 1.333h4.667c.736 0 1.333-.597 1.333-1.333V18c0-.736-.597-1.333-1.333-1.333zm-.667 6h-3.333A.667.667 0 0118 22v-2.667h4.667V22a.667.667 0 01-.667.667z"
      data-original="#d9a4fc"
    ></path>
    <g xmlns="http://www.w3.org/2000/svg" fill="#000">
      <path
        d="M14 8H9.333C8.597 8 8 8.597 8 9.333V14c0 .736.597 1.333 1.333 1.333H14c.736 0 1.333-.597 1.333-1.333V9.333C15.333 8.597 14.736 8 14 8zm-.667 6H10a.667.667 0 01-.667-.667v-2.667H14v2.667a.667.667 0 01-.667.667zM22.667 8H18c-.736 0-1.333.597-1.333 1.333V14c0 .736.597 1.333 1.333 1.333h4.667c.736 0 1.333-.597 1.333-1.333V9.333C24 8.597 23.403 8 22.667 8zM22 14h-3.333a.667.667 0 01-.667-.667v-2.667h4.667v2.667A.667.667 0 0122 14z"
        data-original="#be63f9"
      ></path>
    </g>
  </svg>
}

export default block_icons;